var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconBrowserPageText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 3,
  x: 4,
  y: 8.25,
  rx: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.25 12.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5ZM19.25 16.25h-6a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5"
}), /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 6.5,
  x: 4,
  y: 12.75,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 4.75a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v14.5a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3Zm-14.35-1a1 1 0 0 1 1.7 0 .91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 .91.91 0 0 1 0-1m-3.5 0a1 1 0 0 1 1.7 0 .91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 .91.91 0 0 1 0-1m-3.56.09a1 1 0 0 1 1.76-.09.91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 1 1 0 0 1-.15-.5 1.1 1.1 0 0 1 .09-.41M22 19.25a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a.25.25 0 0 1 .25-.25h19.5A.25.25 0 0 1 22 7Z"
}))));
export default SvgStreamlineIconBrowserPageText;